module.exports = __webpack_public_path__ + "img/lower-pavilion.4de6a249.svg";